import { Component, OnDestroy, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl } from '@angular/forms';

import {debounceTime, startWith, Subject, Subscription } from 'rxjs';

import { AreaListFilterRequest } from '../../../commons/models/remote.request/AreaListFilterRequest';
import { ViewMode } from '../list-lite/area-list-lite.component';
import { Tag } from '../../../commons/models/domain/Tag';
import { AreaService } from '@commons/services/area/area.service';
import { SearchThemeEnum } from '@commons/enums/search-theme.enum';

@Component({
    selector: 'tk-area-list-filter',
    templateUrl: './area-list-filter.component.html',
    styleUrls: ['./area-list-filter.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class AreaListFilterComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {


    @ViewChild('filterBlock') filterBlock?: ElementRef;

    @Output() onHandleOnHeightChanged: EventEmitter<any> = new EventEmitter<any>();

    baseHeight?: number;

    public inputHasFocus = false;

    /**
     * View mode
     */
    @Input() viewMode?: ViewMode;

    /**
     * For template
     */
    public ViewMode = ViewMode;

    /**
     * Form
     */
    public form: FormGroup;

    /**
     * Flag indicating whether filter request is being processed
     */
    public loading = false;

    /**
     * Filter request subject
     */
    public filterRequestSubject: Subject<AreaListFilterRequest> = new Subject<AreaListFilterRequest>();

    /**
     * Subscription to stream of form controls value changess
     */
    private filterRequestSub?: Subscription;

    /**
     * Subscription to stream of value changes
     */
    private formValueChangesSub?: Subscription;

    public searchThemeEnum = SearchThemeEnum;

    /**
     * Component constructor
     * @param $fb form builder
     * @param $area area service
     */
    constructor(
        private $fb: FormBuilder,
        private $area: AreaService
    ) {
        // Prepare form and control
        const Phrase = this.$fb.control(null);
        const Tags = this.$fb.control([]);
        this.form = this.$fb.group({
            Phrase: Phrase,
            Tags: Tags,
        });
    }

    ngOnInit() {


        // Subscribe for form value changes and when fired send filter request
        this.formValueChangesSub = this.form.valueChanges.pipe(
            debounceTime(500),
            startWith(this.form.value))
            .subscribe(form => {
                this.$area.findArea$(form as AreaListFilterRequest);
            });


    }

    ngOnChanges(changes: SimpleChanges) {

        // grey out when edithing
        if (changes && changes['viewMode']) {
            const viewMode = changes['viewMode'].currentValue;
            // When grey-out then should be disabled
            const Phrase = this.form.controls['Phrase'];
            if (viewMode === ViewMode.Form) {
                Phrase.disable();
            } else {
                Phrase.enable();
            }
        }
    }


    /**
     * On destroy lifecycle hook
     */
    public ngOnDestroy(): void {

        if (this.formValueChangesSub) {
            this.formValueChangesSub.unsubscribe();
        }
    }


    /**
     * Handles close event with selected tags
     * @param selectedTags
     */
    public handleOnSelectedTags(selectedTags: Tag[]): void {

        this.form.controls['Tags'].setValue(selectedTags);
    }


    /**
     * Handles enter event from search input
     */
    public onSearchEnter(): void {

        this.$area.findArea$(this.form.value as AreaListFilterRequest);
    }


    /**
     * Handles enter event from search input
     */
    public onClearEnter(): void {

        this.$area.findArea$(this.form.value as AreaListFilterRequest);
    }


    ngAfterViewInit() {
        this.baseHeight = this.filterBlock?.nativeElement.offsetHeight;
    }


    /**
 * Handle container change of tags selector
 */
    public handleOnHeightChanged(h: number) {
        setTimeout(() => {
            const height = this.filterBlock?.nativeElement.offsetHeight;
            let delta = height - this.baseHeight!;
            if (delta < 0) {
                delta = 0;
            }
            this.onHandleOnHeightChanged.emit(this.baseHeight! + delta);
        }, 100);
    }


    onInputFocus(flag: boolean) {
        this.inputHasFocus = flag;
    }
}
